/* tslint:disable */
/* eslint-disable */
/**
 * My API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface CreateSolutionDto
 */
export interface CreateSolutionDto {
    /**
     * 
     * @type {string}
     * @memberof CreateSolutionDto
     */
    'projectId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSolutionDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateSolutionDto
     */
    'source'?: CreateSolutionDtoSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateSolutionDto
     */
    'version'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSolutionDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSolutionDto
     */
    'icon'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSolutionDto
     */
    'image'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateSolutionDto
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CreateSolutionDto
     */
    'metadata'?: { [key: string]: string; };
    /**
     * 
     * @type {boolean}
     * @memberof CreateSolutionDto
     */
    'systemSolution'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSolutionDto
     */
    'localSolution'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateSolutionDto
     */
    'display_name'?: string;
}

export const CreateSolutionDtoSourceEnum = {
    System: 'SYSTEM',
    Custom: 'CUSTOM'
} as const;

export type CreateSolutionDtoSourceEnum = typeof CreateSolutionDtoSourceEnum[keyof typeof CreateSolutionDtoSourceEnum];


